import { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { handleBackendError, openNotification } from "../../../utils/helpers";
import { ShortLinkPayloadType } from "../form/interface";
import ShortLinkRepository from "../../../repositories/short-link-repository";

export const useFormShortLink = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [submitLoading, setSubmitLoading] = useState<boolean>(false);
  const [deleteLoading, setDeleteLoading] = useState<boolean>(false);

  const onDelete = useCallback(
    async (id: number | string) => {
      setDeleteLoading(true);

      return new Promise((resolve, reject) => {
        ShortLinkRepository.delete(id)
          .then((response: AxiosResponse) => {
            resolve(response);
          })
          .catch((e: AxiosError) => {
            handleBackendError(e, t("notification.error.default"));
            reject(e);
          })
          .finally(() => {
            setDeleteLoading(false);
          });
      });
    },
    [t]
  );

  const onSubmit = useCallback(
    async (data: ShortLinkPayloadType, id: string | null = null) => {
      setSubmitLoading(true);

      await (id
        ? ShortLinkRepository.update(id, data)
        : ShortLinkRepository.create(data))
        .then(() => {
          navigate("/short-link");
          openNotification(
            "success",
            t(`notification.success.${id ? "updateItem" : "createItem"}`, {
              item: t("common.text.shortLink"),
            })
          );
        })
        .catch((e: AxiosError) => {
          handleBackendError(e, t("notification.error.default"));
        })
        .finally(() => {
          setSubmitLoading(false);
        });
    },
    [t, navigate]
  );

  return {
    onSubmit,
    submitLoading,
    onDelete,
    deleteLoading,
  };
};